<template>
    <div class="wrapper-form-input-listasuspensa" :class="{'allow-markup-error': markupError}" :inert="!isPreenchimento">
        <p v-if="campo.tituloHtml && (isPreenchimento || pIsConferencia)" class="is-size-6 mb-2 titulo-campo-preenchivel" v-html="campo.tituloHtml"></p>
        <div class="control multiselect-econtador">
            <Multiselect
                placeholder="Selecione o campo"
                :options="opcoesFormatadas"
                :canDeselect="false"
                :canClear="false"
                ref="BlockCampoListaSuspensa"
                @change="(value, select$) => setValue(value)"
                >
            </Multiselect>
        </div>
        <p v-if="isInvalida" class="error-message">
            Campo obrigatório!
        </p>
    </div>
  </template>
  <script>
  import CampoPersonalizado from '../../CampoForm/models/campoPersonalizado.model';
  import Multiselect from '@vueform/multiselect'; //importação normal para evitar condição de corrida ao carregar dados
  export default {
    name: 'TrfPreenchimentoListaSuspensa',
    emits: ['update:value', 'set:validacao'],
    components: {
        Multiselect,
    },
    props: {
        pCampo: {
            type: Object,
            default: new CampoPersonalizado()
        },
        pIsDirty: {
            type: Boolean,
            default: false
        },
        pSocioEmPreenchimento: {
            type: Object,
            default: () => {}
        },
        pIsConferencia: {
            type: Boolean,
            default: false
        },
        isPreenchimento: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
      return {
        campo: this.pCampo,
        formData: {
            respostaOpcoes: []
        },
        isDirty: this.pIsDirty,
        campoIniciado: false
      };
    },
    computed: {
        opcoesFormatadas() {
            let cloneOpcoes = [...this.campo.opcoes];
            cloneOpcoes.sort((a,b) => a.ordem - b.ordem);
            cloneOpcoes = cloneOpcoes.map(opcao => {
                return {
                    label: opcao.label,
                    value: opcao.ordem
                }
            })
            return cloneOpcoes
        },
        isInvalida() {
            if (!this.required) return false;
            return this.isDirty && (!Array.isArray(this.formData.respostaOpcoes) || this.formData.respostaOpcoes.length == 0)
        },
        markupError() {
            return this.isPreenchimento && this.isInvalida
        }
    },
    watch: {
        pIsDirty: {
            immediate: true,
            handler(novo) {
                this.isDirty = novo
            }
        },
        isInvalida: {
            immediate: true,
            handler(novo) {
                if(this.required) {
                    this.$emit('set:validacao', !novo);
                }
            }
        },
        pCampo: {
            immediate: true,
            handler(novo) {
                if (this.campoIniciado) return;
                let respostaDoCampo = null;

                if(novo?.isCampoSocio && Array.isArray(novo?.respostasSocios)) {
                    respostaDoCampo = novo.respostasSocios.find((resposta) => {
                        return (resposta.processoSocioId != null && resposta.processoSocioId == this.pSocioEmPreenchimento.socio.id) || (resposta.uuid != null && resposta.uuid == this.pSocioEmPreenchimento.socio.uuid)
                    })
                }
                const respostaPreenchimento = respostaDoCampo? respostaDoCampo.respostaOpcoes : this.pCampo.respostaOpcoes;
                this.formData.respostaOpcoes = respostaPreenchimento? respostaPreenchimento : [];
                this.iniciarCampoEditavel()
            }
        },
    },
    methods: {
        async iniciarCampoEditavel() {
            this.campoIniciado = true;
            if ((!this.isPreenchimento && !this.pIsConferencia) || this.formData.respostaOpcoes.length == 0) return;
            await this.$nextTick();
            this.$refs.BlockCampoListaSuspensa.select(this.formData.respostaOpcoes[0])
            this.emitValue(this.formData);
        },

        setValue(value) {
            const valueArray = [value];
            this.formData.respostaOpcoes = valueArray;
            this.emitValue(this.formData)
            this.isDirty = true
        },

        emitValue(value) {
            if (!this.campoIniciado || this.isConferencia) return;
            this.$emit('update:value', value)
        },
    }
  };
  </script>